import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { format, addMonths, subMonths } from 'date-fns'
import IconButton from '@mui/material/IconButton'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Typography from '@mui/material/Typography'


const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  left: {
    flexGrow: 1
  },
  date: {
    fontWeight: 600,
    fontSize: '1.2rem'
  }
})


const CalendarHeader = props => {
  const classes = useStyles()
  const dateFormat = 'MMMM yyyy'
  const { date, setDate } = props


  function nextMonth() {
    const newDate = addMonths(date, 1)
    setDate(newDate)
  }


  function previousMonth() {
    const newDate = subMonths(date, 1)
    setDate(newDate)
  }


  return (
    <div className={ classes.root }>
      <div className={ classes.left }>
        <Typography className={ classes.date } component='span'>
          { format(date, dateFormat) }
        </Typography>
      </div>

      <div>
        <IconButton onClick={ previousMonth } size="large">
          <ChevronLeftIcon color='primary' />
        </IconButton>

        <IconButton onClick={ nextMonth } size="large">
          <ChevronRightIcon color='primary' />
        </IconButton>
      </div>
    </div>
  );
}

export default CalendarHeader